export default "__VITE_ASSET__cfb8bd8f__"